var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqsIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 33,
    viewBox: "0 0 44 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10637_17263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9161 0.709473C40.0656 0.709473 41.0022 1.64605 41.0022 2.79548V28.1468H3V2.79548C3 1.64605 3.93657 0.709473 5.086 0.709473H38.9161Z",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1137 28.1467C43.1137 30.4314 41.3896 32.2904 39.261 32.2904H4.73553C2.60696 32.2904 0.882812 30.4385 0.882812 28.1467H43.1137Z",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.918 10.189V14.957",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0398 11.0332L8.79688 14.1125",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0398 14.1125L8.79688 11.0332",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3828 10.1887V14.9567",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5047 11.033L16.2617 14.1123",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5047 14.1123L16.2617 11.033",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9453 10.189V14.957",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0743 11.0332L23.8242 14.1125",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0743 14.1125L23.8242 11.0332",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.418 10.189V14.957",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5398 11.0332L31.2969 14.1125",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5398 14.1125L31.2969 11.0332",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20312 17.7168H36.9535",
    stroke: "#148D9B",
    strokeWidth: 1.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10637_17263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.65,
    height: 33,
    fill: "white",
    transform: "translate(0.175781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqsIcon9);
export default __webpack_public_path__ + "static/media/faqs-icon-9.18164d1acf1c330adaeeb11e4748dccb.svg";
export { ForwardRef as ReactComponent };